import { bootstrap } from '@/apps/bootstrap';

window.DESIGNER = window.DESIGNER || {};
window.DESIGNER.bootstrap = (...args) => bootstrap(...args);
